<div class="custom-container-home">
  <div class="img-fondo-home">
    <div class="ms-4">
      <app-hamburger-menu></app-hamburger-menu>
    </div>
    <div class="d-flex flex-column align-items-center move-cards px-3 pb-5">
      <div class="card-portal gap-2 d-flex flex-column mb-4">
        <div class="text-center d-flex flex-column align-items-center">
          <p class="text-174D9C text-montserrat text-800 text-18">¡Hola!</p>
    
          @if (user) {
          <p class="text-2A2A59 text-montserrat text-800 text-18 mb-3">{{ user.trab_nombres }} {{
            user.trab_apellido_paterno }} {{ user.trab_apellido_materno }}</p>
          }
    
          <p class="text-174D9C text-montserrat text-800 text-16 mb-0">Te damos la bienvenida</p>
          <p class="text-474756 text-nunito text-500 text-14 mb-1">Tus cursos y toma de asistencia en un solo lugar.</p>
        </div>
        <img src="assets/images/line-card.svg" alt="">
      </div>
      @if (bloqueEnCursoAsistencia) {
      <div class="card-portal gap-2 d-flex flex-column mb-5">
        <div class="d-flex flex-column">
          <p class="text-center text-1D2345 text-montserrat text-700 text-14 mb-1">{{ nombreAcca }}</p>
          <p class="text-center text-383D42 text-nunito text-500 text-14 mb-1">En curso. Puedes tomar asistencia.</p>
        </div>
        <button class="btn btn-blue w-100" (click)="goTomarAsistencia(accaId, true)">Tomar Asistencia</button>
      </div>
      }
      <div class="d-flex align-items-center justify-content-between w-100" style="max-width: 640px;">
        <div class="d-flex flex-column align-items-center justify-content-center btn-home mb-5" (click)="goConfiguracion()">
          <img src="assets/icons/configuracion.svg" alt="" class="mb-1">
          <p class="text-nunito text-500 text-12 text-FFFFFF mb-0">
            Configuración
          </p>
        </div>
        <div class="d-flex flex-column align-items-center justify-content-center btn-home mb-5" (click)="goSeguimiento()">
          <img src="assets/icons/seguimiento.svg" alt="" class="mb-1">
          <p class="text-nunito text-500 text-12 text-FFFFFF mb-0">
            Seguimiento
          </p>
        </div>
        <div class="d-flex flex-column align-items-center justify-content-center btn-home mb-5" (click)="goReportes()">
          <img src="assets/icons/reportes.svg" alt="" class="mb-1">
          <p class="text-nunito text-500 text-12 text-FFFFFF mb-0">
            Reportes
          </p>
        </div>
      </div>
      <img src="assets/images/line.svg" alt="" class="img-fluid w-100" style="max-width: 1000px; margin-bottom: 30px;">
    </div>
  </div>
</div>